export const RECTANGLE_BORDER_COLORS = {
  primary: 'orange',
  secondary: 'turquoise',
  positive: 'green',
  negative: 'red',
  disabled: 'disabled'
}

export const BUTTON_FILL_COLORS = {
  primary: 'orange',
  secondary: 'turquoise',
  positive: 'green',
  negative: 'red',
  disabled: 'disabled',
  default: 'backgroundRush'
}

export const RECTANGLE_BUTTON_SIZING = {
  s: { width: 90, height: 30 },
  m: { width: 120, height: 40 },
  l: { width: 150, height: 50 },
  xl: { width: 180, height: 60 }
}

export const ROUND_BUTTON_SIZING = {
  s: 30,
  m: 40,
  l: 50,
  xl: 60
}

export const ROUND_BUTTON_HOVER_COLORS = {
  default: 'turquoise'
}

export const ICON_COLORS = {
  disabled: 'background',
  default: 'gray'
}

export const ROUND_ICON_COLORS = {
  disabled: 'disabled',
  default: 'gray'
}

export const ROUND_SCALE_BUTTON_SIZING = {
  m: 80,
  l: 120
}
